module.exports = __webpack_public_path__ + "img/box9-20.ca34da24.png";